import { BROKER_IDENTIFIERS_PATH } from '../../../../constants'
import AbstractService from '../../../../services/AbstractService'

import {
  BrokerIdentifierList,
  CreateBrokerIdentifierRequest,
  CreateBrokerIdentifierResponse,
  DeleteBrokerIdentifierRequest,
  GetBrokerIdentifiersResponse,
} from './types'

class BrokerIdentifiersApiClass extends AbstractService {
  getIdentifiers = () =>
    this.request<GetBrokerIdentifiersResponse>(BROKER_IDENTIFIERS_PATH, 'get', false)

  createIdentifier = (data: CreateBrokerIdentifierRequest) =>
    this.request<CreateBrokerIdentifierResponse>(BROKER_IDENTIFIERS_PATH, 'post', false, data)

  deleteIdentifier = ({ id }: DeleteBrokerIdentifierRequest) =>
    this.request<void>(`${BROKER_IDENTIFIERS_PATH}/${id}`, 'delete', false)
}

export const BrokerIdentifiersApi = new BrokerIdentifiersApiClass()
export type { BrokerIdentifierList }
